module.exports = __webpack_public_path__ + "img/SE.3cf10713.svg";